// TelcoTrack — /vydelek-firmy: správce firmy, finance a role s cizím výkazem.
// Neotevírá modul Firmy.

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { canReadCompanyEarnings } from '@core/shared-bridge';
import { AuthService } from '../services/auth.service';

export const companyEarningsGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (canReadCompanyEarnings(auth.getSessionRoles())) return true;
  void router.navigate(['/403']);
  return false;
};
